import Commands from './commands';

class Conditional extends Commands {
    constructor(registry) {
        super("if", registry);
    }

    async execute(node, emitter, options) {
        const condition = await emitter(node.params[0], options);
        if (condition) {
            return await emitter(node.params[1], options);
        } else {
            return await emitter(node.params[2], options);
        }
    }
}

export default Conditional;
